import React from "react";
import { Layout, Row, Col, Divider } from "antd";

import Breadcrumb from "../Components/Navigation/Breadcrumb";
import UserContext from "../Contexts/UserContext";
import OrdersComponent from "../Components/Orders/OrdersComponent";

const { Content } = Layout;

const Orders = () => {
  return (
    <UserContext.Consumer>
      {({ profile }) => (
        <Content style={{ background: "#fff", padding: "16px 32px" }}>
          <Breadcrumb />
          <Row>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <h1 style={{ marginBottom: 0 }}>Listado de órdenes</h1>
              </div>
              <Divider />
            </Col>
            <Col span={24}>
              <OrdersComponent profile={profile} />
            </Col>
          </Row>
        </Content>
      )}
    </UserContext.Consumer>
  );
};

export default Orders;



// WEBPACK FOOTER //
// ./src/Pages/Orders.js